import { render } from "./CourtesyView.vue?vue&type=template&id=10bab56c&scoped=true"
import script from "./CourtesyView.vue?vue&type=script&lang=js"
export * from "./CourtesyView.vue?vue&type=script&lang=js"

import "./CourtesyView.vue?vue&type=style&index=0&id=10bab56c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10bab56c"]])

export default __exports__